module.exports = __webpack_public_path__ + "img/service-bg.94d49e53.png";